import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import httpManager from '../../util/common'
import TitleLabel from '../components/TitleLabel'
Vue.config.productionTip = false
Vue.use(Antd)

let iconPath = '/static/images/event/'

let vm = {
  delimiters: ['{', '}'],
  name: 'entity-events',
  components: {TitleLabel},
  props: ['oaid'],
  data: () => {
    return {
      page: {
        pagenum: 1,
        pagesize: 5,
        total: 0,
        pagerCount:3,
        align: 'center',
        layouts: ['PrevPage', 'Number','NextPage'],
        perfect: true,
      },
      entity_events_info: [],
      divloading: false
    }
  },
  mounted () {
    this.getESGData(1)
    // this.callIndicationTable()
  },
  methods: {
    showSentimentIcon (sentiment) {
      let lan = ''
      if (this.$i18n.locale === 'en'){
        lan = '-en'
      }
      return iconPath + '/sentiment' + sentiment + lan + '.png'
    },
    showImpactLevelIcon (sentiment, impactLevel) {
      let lan = ''
      if (this.$i18n.locale === 'en'){
        lan = '-en'
      }
      let sentiment2color = {'-1': 'red', '0': 'orange', '1': 'green'}
      if (sentiment in sentiment2color) {
        if (impactLevel != null) {
          return iconPath + impactLevel + 'l' + sentiment2color[sentiment] + lan  + '.png'
        } else {
          return iconPath + sentiment2color[sentiment] + lan  + '.png'
        }
      } else {
        return iconPath + 'orange' + lan + '.png'
      }
    },
    handleClick (e) {
      console.log('click', e)
    },
    titleClick (e) {
      console.log('titleClick', e)
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.getESGData(currentPage)
    },
    getESGData (pageNumber) {
      let self = this
      self.divloading = true
      let oaid = this.oaid
      let params = new Map()
      params.set('oaid', oaid)
      params.set('pagenum', pageNumber)
      params.set('pagesize', self.page.pagesize)
      httpManager('esg_event', params)
        .then(response => {
          self.page.total = response.data.page.total
          self.entity_events_info = response.data.data
          self.divloading = false
        })
        .catch(error => {
          console.log(error)
          self.divloading = false
        })
    }
  }
}

export default vm



// WEBPACK FOOTER //
// ./src/entity/js/entity_events.js